import React from 'react';
import { string } from 'prop-types';

import Text from '~components/Text';

import styles from './styles.module.scss';

const Head = ({ title }) => (
  <div className={`row middle m-top-5 ${styles.head}`}>
    <Text className={`m-left-3 text-uppercase bold ${styles.title}`}>{title}</Text>
  </div>
);

Head.propTypes = {
  title: string
};

export default Head;
